import React from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import OnBoardingSkip from "./Components/OnBordingSkip";
import StepProgress from "./Components/StepProgress";
import SelectSource from "./Components/SelectSource/SelectSource";
import SelectSourceTranscript from "./Components/SelectSource/SelectSourceTranscript";
import AddContent from "./Components/AddContent/AddContent";
import AddContentTranscript from "./Components/AddContent/components/AddContentTranscript";
import ThemeLayouts from "./Components/Publish/components/ThemeLayouts";
import { createFeedAction, getNetworkInfoById, getNetworks } from "../../../../actions/addFeedActions";
import OnboardingPreview from "./Components/Preview.js";
import { changeTheme, getWidgetWallData } from "../../../../actions/wallDataAction.js";
import { refreshThemes } from "../../../../actions/firstRunAction.js";
import { useNavigate } from "react-router-dom";
import { CalendlyPop, GET_NETWORK_ICON, SOCKET_CONNECTION, TOAST_SUCCESS, decrypt, encrypt, getInitialRoute, setCookie, showAddAccountAlertNew } from "../../../../utils/index.js";
import { getUpdatedExtraData, getUseronboardingInfo } from "../../../../actions/loginActions.js";
import { dasktopSkip, SHOW_DEMO_POST } from "../../../../actions/wallsAction.js";
import { toast } from "react-toastify";
import { LIVE_API, SW_LOGO, SW_LOGO_ICON } from "../../../../actions/api.js";
import { createWall, selectProduct } from "../../../../actions/initActions.js";
import { USER_AUTHENTICATED_LOGIN } from "../../../../reducers/keys.js";
import { connect } from "react-redux";
import { Cookies } from 'react-cookie';
import Verification from "./Components/Verification.js";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper.js";
import { toggleAddFeedsSection_D } from "../../../../actions/showDisplayModalAction.js";
import ExitPopup from "./Components/ExitPopup.js";
import CollectContentSkeleton from "./Components/CollectContentSkeleton.js";



const HIDDEN_ONBOARDING_NETWORKS = ["snapup", "photo booth", "request new network", "custom post"];
// returned by createUserWall when it hit a 401 and handed off to a token refresh that re-runs the network load
const RETRYING = "retrying";
const cookies = new Cookies();

const OnBoarding = (props) => {
    const navigation = useNavigate();
    const dispatch = useDispatch();
    const { wallData } = useSelector(state => state.wallData, shallowEqual)
    return <OB {...props} navigation={navigation} dispatch={dispatch} wallData={wallData} />;
}
class OB extends React.Component {
    constructor(props) {
        super(props);
        // while the "verify your email" or "email verified" popup is pending, hold off starting the left chat panel and loading network sources until the latter is dismissed via "Let's Go"
        const pendingEmailConfirmation = props.userDetails?.user?.access == 2 || props.userDetails?.user?.email_confirmation == 0;
        const pendingEmailVerification = props.userDetails?.user?.access != 2 && cookies.get('emailConfirmation') == "true";
        this.state = { stepCompleted: 0, selectedNetworkId: null, networkList: [], networkLoading: false, networkError: false, themeRequest: false, postCount: null, filterTabs: [], selectedFilterId: null, selectedFilterType: null, wallId: null, userData: {}, feedName: '', creationAttemp: 1, showPop: false, selectedProductId: null, selectedProductName: null, data: [], loading: false, noNewtwork: false, creatingWall: false, showThemePanel: false, collectingContent: false, hasSelectedNetworkOnce: false, hasFeed: false, feedCreated: false, collectDone: false, previewKey: 0, chatStarted: !(pendingEmailConfirmation || pendingEmailVerification) }
        this.chatScrollRef = React.createRef();
    }

    updatedSelectedNetwork = (networkId) => {
        this.setState({ selectedNetworkId: networkId, hasSelectedNetworkOnce: true });
    }

    updatedSelectedFilter = (filterData) => {
        this.setState({ selectedFilterId: filterData.filter, selectedFilterType: filterData.feedtype });
    }

    updateStep = (step, data, callback) => {
        const { selectedNetworkId, wallId, creationAttemp } = this.state;
        const { dispatch, wallData } = this.props;

        if (step == 1 && selectedNetworkId) {
            this.setState({ themeRequest: true });
            getNetworkInfoById(selectedNetworkId).then(res => {
                const { responseData } = res.data;

                let filterId = null;
                let filterType = null;
                if (responseData.length > 0 && responseData[0].networkTab.length == 1) {
                    filterId = responseData[0].networkTab[0].filter;
                    filterType = responseData[0].networkTab[0].feedtype;
                }
                if (selectedNetworkId == 15) {
                    filterId = 15;
                    filterType = 'workplace';
                }
                let selectedNList = [4, 19, 23, 2, 18];
                if (getInitialRoute() != "widget") selectedNList = [1, 7, 10, 28];
                if (selectedNList.includes(Number(selectedNetworkId)) && !(wallData && Object.keys(wallData).length > 0)) {
                    dispatch(getWidgetWallData(localStorage.getItem('ownerId'), wallId));
                }
                this.setState({ filterTabs: responseData.length > 0 ? responseData[0].networkTab : [], stepCompleted: step, selectedFilterId: filterId, themeRequest: false, selectedFilterType: filterType });

            }).catch(ex => {
                console.log(ex, "error");
                this.setState({ themeRequest: false });
            });
        } else if (step == 2 && wallId && data && Object.keys(data).length > 0) {
            data = { ...data, wallId: wallId };
            this.setState({ collectingContent: true, feedCreated: false, collectDone: false });

            createFeedAction(data, data.networkId, (postDetails, responseCode, responseMsg) => {
                const { postCount, feedName } = (postDetails && Object.keys(postDetails).length > 0) ? postDetails : { postCount: null, feedName: '' };
                const finish = () => {
                    this.setState({ collectingContent: false });
                    if (responseCode && responseCode == 404 && responseMsg && responseMsg.includes('Feed Already Created.')) {
                        this.socketAction(true);
                        this.skipAction();
                    }
                    if (responseCode && (responseCode == 403) && (data.networkId == 18 || data.networkId == 1)) {
                        showAddAccountAlertNew({ id: data.networkId, name: GET_NETWORK_ICON(data.networkId) }, "addFeed");
                    }
                    if (postCount == 0 && creationAttemp < 3) {
                        const msg = <div><strong>Info</strong><p className="mb-0">0 posts collected from this feed. Try a different feed, perhaps?</p></div>;
                        toast.info(msg, { autoClose: 3000 });
                        if (creationAttemp == 2) this.skipAction();
                        this.setState({ creationAttemp: creationAttemp + 1 }, this.backAction);
                    }
                    if (postCount) {
                        dispatch(refreshThemes());
                        this.updateExtraData();
                        // remember that a feed exists for this wall, independent of postCount, so "Change source" (which clears postCount) doesn't hide the ability to jump back to Publish
                        this.setState({ hasFeed: true });
                        if (getInitialRoute() == "widget" && [4, 19, 23, 2, 18].includes(Number(selectedNetworkId))) {
                            const themeToApply = [2, 18].includes(selectedNetworkId) ? 16 : 47;
                            this.changeOnboardingTheme({ wallData, themeToApply, dispatch }, () => this.setState({ stepCompleted: step, postCount: postCount, feedName: feedName }, () => this.socketAction(true)), false);
                        } else {
                            if (getInitialRoute() != "widget" && [1, 7, 10, 28].includes(Number(selectedNetworkId))) {
                                let themeToApply = 69;
                                if ([1, 10].includes(selectedNetworkId)) themeToApply = 66;
                                setCookie('eventPopup', "1", { path: '/' });
                                this.changeOnboardingTheme({ wallData, themeToApply, dispatch }, () => this.setState({ stepCompleted: step, postCount: postCount, feedName: feedName }, () => this.socketAction(true)), true);
                            } else {
                                this.setState({ stepCompleted: step, postCount: postCount, feedName: feedName }, () => {
                                    this.socketAction(true);
                                    dispatch(getWidgetWallData(localStorage.getItem('ownerId'), wallId));
                                }, wallId);
                            }
                        }
                    }
                    callback();
                };
                // posts were collected - let the progress indicator reach 100% before moving on to the Publish step
                if (postCount) this.setState({ collectDone: true }, () => setTimeout(finish, 700));
                else finish();
            }, () => this.setState({ feedCreated: true }));

        }
    }

    changeOnboardingTheme = (themeData, callback, isDisplay) => {
        // the onboarding preview iframe URL doesn't include the theme, so Themes never reloads it on a theme change - remount the preview once the new theme is applied
        changeTheme(themeData, () => this.setState(({ previewKey }) => ({ previewKey: previewKey + 1 }), callback), isDisplay);
    }

    componentDidMount() {
        this.socketAction(false);
        if (this.state.chatStarted) this.getAllNetwork();
    }

    // triggered when the email-verified popup is dismissed via "Let's Go": starts the left chat panel and loads network sources
    startOnboardingChat = () => {
        if (this.state.chatStarted) return;
        this.setState({ chatStarted: true }, () => this.getAllNetwork());
    }

    checkUserPost() {
        const { userWalls } = this.props;
        const { wallId } = this.state;
        const setWall = userWalls.find(w => w.wall?.id == wallId)
        if (setWall) {
            if (setWall.postCount > 0 && this.state.stepCompleted < 2) this.setState({ stepCompleted: 2, postCount: setWall.postCount, hasFeed: true });
        }
        else if (userWalls?.length > 0) {
            const postCount = userWalls[0].postCount;
            if (postCount > 0 && this.state.stepCompleted < 2) this.setState({ stepCompleted: 2, postCount, hasFeed: true });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { networkList, noNewtwork } = this.state;
        const decryptData = decrypt(localStorage.getItem("user_data"));
        const userDetails = JSON.parse(decryptData);
        if (userDetails && Object.keys(userDetails).length > 0 && userDetails.user && Object.keys(userDetails.user).length > 0) {
            if (this.state.chatStarted && userDetails.user.access == 1 && !noNewtwork && !this.state.networkLoading && !(networkList?.length > 0)) {
                this.setState({ noNewtwork: true }, this.getAllNetwork);
            }
        }
        this.checkUserPost();
        if (prevState.stepCompleted !== 2 && this.state.stepCompleted === 2) this.scrollChatToBottom();
        if (!prevState.postCount && this.state.postCount && this.state.wallId) this.hideDemoPosts();
    }

    // the wall starts with demo posts enabled; turn them off once real posts exist (the app does the same in moderation) and remount the preview, otherwise it keeps rendering demo posts
    hideDemoPosts = () => {
        SHOW_DEMO_POST(0, this.state.wallId).catch(() => { }).finally(() => this.setState(({ previewKey }) => ({ previewKey: previewKey + 1 })));
    }

    scrollChatToBottom = () => {
        const node = this.chatScrollRef.current;
        if (node) node.scrollTop = node.scrollHeight;
    }

    updateExtraData = () => {
        const { userData } = this.state;
        if (userData && Object.keys(userData).length > 0) {
            let data = { ...userData };
            let extraData = data['user']['extra_data'];
            extraData = extraData.length > 0 ? JSON.parse(extraData) : {};
            extraData['skip_onboarding'] = true;
            extraData['created_feed'] = true;
            data['user']['extra_data'] = JSON.stringify(extraData);
            if (data && Object.keys(data).length > 0) {
                const encryptedData = encrypt(JSON.stringify(data));
                localStorage.setItem('user_data', encryptedData);
            }
        }
    }

    createUserWall = async (userData, dispatch) => {
        if (this.state.creatingWall) return;
        this.setState({ creatingWall: true });
        try {
            const wallResponse = await createWall();
            const wall = wallResponse.data.responseData;
            if (wall && Object.keys(wall).length > 0) {
                const wallId = wall.wallId;
                if (wallId && userData && Object.keys(userData).length > 0) {
                    let data = { ...userData };
                    data['user']['wallIdDesc'] = wallId;
                    if (data && Object.keys(data).length > 0) {
                        const updatedData = encrypt(JSON.stringify(data));
                        localStorage.setItem('user_data', updatedData);
                        // keep Redux's copy of the user in sync too - otherwise getUpdatedExtraData's success handler (which rebuilds localStorage from the stale Redux copy) wipes this wallId back out on the very next call, making the app think this first-time user still has no wall and re-creating one, restarting onboarding from Step 1
                        dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: data });
                    }
                    return wallId;
                }
            }
        } catch (ex) {
            // refresh the token, then run the whole network load again (it re-creates the wall since none was saved)
            if (ex?.response?.status === 401) {
                dispatch(getUseronboardingInfo(this.getAllNetwork, false));
                return RETRYING;
            }
        } finally {
            this.setState({ creatingWall: false });
        }
    }

    // single entry point for loading network sources - a call made while one is already running (mount, componentDidUpdate, a retry) reuses it instead of racing it
    getAllNetwork = () => {
        if (!this.networkRequest) this.networkRequest = this.loadNetworks().finally(() => { this.networkRequest = null; });
        return this.networkRequest;
    }

    loadNetworks = async () => {
        const { dispatch } = this.props;
        this.setState({ networkLoading: true, networkError: false });
        // every path that ends without networks (and without a token refresh that re-runs this) shows the Retry state instead of an empty grid
        const failed = () => this.setState({ networkLoading: false, networkError: true });
        try {
            let userDetails = null;
            try { userDetails = JSON.parse(decrypt(localStorage.getItem("user_data"))); } catch (ex) { }
            if (!(userDetails?.user && Object.keys(userDetails.user).length > 0)) {
                dispatch(getUseronboardingInfo());
                return failed();
            }
            let wallId = userDetails.user.wallIdDesc;
            const rawExtraData = userDetails.user.extra_data;
            let extraData = {};
            try { extraData = typeof rawExtraData == 'string' ? (rawExtraData ? JSON.parse(rawExtraData) : {}) : (rawExtraData || {}); } catch (ex) { }
            const skip_onboarding = extraData?.skip_onboarding == true;
            const created_feed = extraData?.created_feed == true;
            if (userDetails.user.access == 1) {
                if (!wallId) {
                    const newWallId = await this.createUserWall(userDetails, dispatch);
                    if (newWallId === RETRYING) return;
                    wallId = newWallId;
                }
                dispatch(getUpdatedExtraData({ user_wall_log: wallId }));
            }
            if (!wallId) {
                dispatch(getUseronboardingInfo());
                return failed();
            }
            localStorage.setItem('wallId', wallId);
            if (!skip_onboarding) localStorage.setItem('isOnboarding', 1);
            this.setState({ wallId: wallId, userData: userDetails });
            // a feed was already created in a previous visit (e.g. before a page refresh) - resume straight at Step 3 (Publish) instead of restarting from network selection
            if (created_feed) {
                this.setState({ hasFeed: true });
                if (this.state.stepCompleted < 2) {
                    this.setState({ stepCompleted: 2 });
                    dispatch(getWidgetWallData(localStorage.getItem('ownerId'), wallId));
                }
            }
            const { data } = await getNetworks();
            if (!Array.isArray(data?.networks)) return failed();
            this.setState({ networkList: data.networks.filter(network => !HIDDEN_ONBOARDING_NETWORKS.includes(network.networkName?.trim().toLowerCase())), noNewtwork: true, networkLoading: false });
        } catch (ex) {
            // token expired: refresh it and load again; the spinner stays up meanwhile
            if (ex?.response?.status == 401) dispatch(getUseronboardingInfo(this.getAllNetwork, false));
            else failed();
        }
    }

    skipAction = () => {
        var self = this;
        const { navigation, dispatch } = self.props;

        dispatch(getUpdatedExtraData({ skip_onboarding: true }));
        setTimeout(() => dispatch(dasktopSkip(navigation, true)), 500);
    }

    backAction = () => {
        // clear the stale step-2 selection too, so AddContentTranscript's unmount guard and its bubble conditions agree instead of briefly disagreeing on "Change source"
        this.setState({ stepCompleted: 0, selectedNetworkId: null, selectedFilterId: null, selectedFilterType: null, filterTabs: [], postCount: null, feedName: '' });
    }

    toggleThemePanel = () => {
        this.setState({ showThemePanel: !this.state.showThemePanel });
    }

    // leaving onboarding (Publish / Go to dashboard): show a success toast, then navigate
    handleNavigation = (route) => {
        TOAST_SUCCESS('Great! All steps are completed. Your wall is ready!');
        this.navigateAway(route);
    }

    navigateAway = (route) => {
        const { dispatch, navigation, } = this.props;
        const { wallId } = this.state;
        dispatch(getWidgetWallData(null, wallId));
        navigation(route);
        if (route?.includes('/wall/index')) dispatch(toggleAddFeedsSection_D(true));
        setCookie('eventPopup', "1", { path: '/' });
        dispatch(getUpdatedExtraData({ skip_onboarding: true }));
        setTimeout(() => { localStorage.setItem('isOnboarding', 0) }, 2000);
    }

    toggleMenuInMobile = () => {
        const elements = document.getElementsByClassName('onboarding-aside-main');
        if (elements.length > 0) {
            const item = elements[0];
            item.classList.toggle("active");
        }
    }

    // socket listening to onboarding process. If it is completed then it will move to home page and emit when onboarding is completed.
    socketAction = (emit) => {
        const userId = localStorage.getItem('ownerId');
        if (emit) SOCKET_CONNECTION.emit(`onboarding-skip`, { ownerId: userId, action: 'onboarding', product: 'socialwalls' });
        else {
            var self = this;
            SOCKET_CONNECTION.on(`onboarding-completed-${userId}`, function (response) {
                const { ownerId, action } = response;
                // close the other tab if it is still on onboarding.
                if (ownerId && ownerId == userId && action == 'onboarding' && parseInt(self.state.stepCompleted) > 0 && parseInt(self.state.stepCompleted) < 2 && self.skipAction) {
                    self.skipAction();
                }
            });
        }
    }

    getProduct = () => {
        const { userDetails } = this.props;
        if (userDetails && userDetails.user && Object.keys(userDetails.user).length > 0 && userDetails.user.access == 1) {
            this.setState({ selectedProductId: 4, selectedProductName: "socialwalls" }, this.onSubmit);
        }
    }


    verificationProduct = () => {
        const { data } = this.state;
        if (data.length && data.length == 1) this.setState({ selectedProductId: 4, selectedProductName: "socialwalls" }, this.onSubmit)
    }

    moveAction = (type) => {
        const { wallId, postCount } = this.state;
        const { navigation, dispatch } = this.props;
        dispatch(getUpdatedExtraData({ skip_onboarding: true }));
        dispatch(getWidgetWallData(null, wallId, () => {
            localStorage.setItem('isOnboarding', 0);
            navigation(`/wall/${type == 1 ? "index" : "preview"}/${wallId}`, { replace: true });
            if (!postCount) dispatch(toggleAddFeedsSection_D(true));
        }));
    }


    onSubmit = event => {
        const { selectedProductId, selectedProductName } = this.state;
        const { navigation, userDetails } = this.props;

        if (LIVE_API && window.fpr && userDetails && userDetails.user && Object.keys(userDetails.user).length > 0 && !String(userDetails.user.emailId).includes('taggbox.com')) {
            window.fpr("referral", { email: userDetails.user.emailId });
        }

        this.setState({ loading: true }, () => {
            this.props.selectProduct({ productId: String(selectedProductId), productName: selectedProductName }, navigation, () => this.socketAction(true))
        });
    }

    render() {
        const { stepCompleted, wallId, postCount, selectedNetworkId, feedName, showPop, data, showThemePanel, networkList, filterTabs, selectedFilterId, collectingContent, chatStarted, hasFeed, previewKey, feedCreated, collectDone } = this.state;
        const { wallData, dispatch } = this.props;
        return (
            <div className={`addfeed-modal-update ${getInitialRoute() == 'socialwalls' ? 'sw_theme' : ''}`} style={{ zIndex: 1000 }}>
                <div className="ob-topbar d-flex align-items-stretch">
                    <div className={`ob-topbar-logo-slot d-flex align-items-center ${showThemePanel ? 'bg-white' : ''}`}>
                        <div className="ob-topbar-logo">
                            <img src={SW_LOGO} alt="Social Walls" className="ob-logo-full" />
                            <img src={SW_LOGO_ICON} alt="Social Walls" className="ob-logo-icon" />
                        </div>
                    </div>
                    <div className="ob-topbar-main flex-grow-1 position-relative d-flex flex-column justify-content-center">
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <StepProgress stepCompleted={stepCompleted} selectedNetworkId={selectedNetworkId} hasFeed={hasFeed} collectingContent={collectingContent} onGoToSelectSource={this.backAction} onGoToPublish={() => this.handleNavigation(`/wall/preview/${wallId}`)} />
                            <span className="ob-topbar-skip cursor-pointer" onClick={this.skipAction}>Skip</span>
                        </div>
                        <div className="ob-topbar-main-border"></div>
                    </div>
                </div>

                {chatStarted ? <div className="row m-0">
                    <div className="w-20 p-0">
                        <div className="onboarding-aside-main">
                            <div className={`onboarding-aside ${showThemePanel ? 'theme-open' : ''}`}>
                                <div className="onboarding-aside-scroll" ref={this.chatScrollRef}>
                                    <OnBoardingSkip />
                                    <div className="p-4">
                                        <SelectSourceTranscript selectedNetworkId={selectedNetworkId} networkList={networkList} stepCompleted={stepCompleted} />
                                        <AddContentTranscript selectedNetworkId={selectedNetworkId} filterTabs={filterTabs} selectedFilterId={selectedFilterId} postCount={postCount} feedName={feedName} stepCompleted={stepCompleted} />
                                        {this.state.stepCompleted === 2 ? (
                                            <div className="mb-3 clearfix ob-step-block-3">
                                                <div className="ob-step-pill">Step 3</div>
                                                <div className="selectSource-chatbox mt-3">
                                                    <div className="selectSource-list">
                                                        <p>Your wall is ready to go! 🚀 <strong>Publish</strong> it with this layout or switch to another one from the options on the right.</p>
                                                    </div>
                                                    <div className="ob-publish-actions mt-3">
                                                        <button type="button" className="ob-btn-gradient" onClick={() => this.handleNavigation(`/wall/preview/${wallId}`)}>Publish</button>
                                                        <button type="button" className={`ob-btn-outline ${showThemePanel ? 'active' : ''}`} onClick={this.toggleThemePanel}>Change theme</button>
                                                        <button type="button" className="ob-btn-dark-outline" onClick={() => this.handleNavigation('/walls/home')}>Go to dashboard</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>

                                {showThemePanel ? (
                                    <ThemeLayouts wallData={wallData} dispatch={dispatch} changeOnboardingTheme={this.changeOnboardingTheme} onClose={this.toggleThemePanel} onPublish={() => this.handleNavigation(`/wall/preview/${wallId}`)} />
                                ) : null}
                            </div>
                            <div className="onbording_toggle_icon" onClick={() => this.toggleMenuInMobile()}>
                                <FontAwesomeIcon type={'solid'} icon={'angles-right'} iconClass={''} />
                            </div>
                        </div>
                    </div>
                    <div className="w-80">
                        <div className="ob-main-panel">
                            <SelectSource {...this.state} updatedSelectedNetwork={this.updatedSelectedNetwork} updateStep={this.updateStep} onRetryNetworks={this.getAllNetwork} />
                            {collectingContent ? <CollectContentSkeleton feedCreated={feedCreated} done={collectDone} /> : <AddContent {...this.state} updatedSelectedFilter={this.updatedSelectedFilter} updateStep={this.updateStep} backAction={this.backAction} />}
                            {stepCompleted == 2 ? <OnboardingPreview key={previewKey} wallData={wallData} wallId={wallId} hasPosts={!!(postCount || hasFeed)} /> : null}
                        </div>
                    </div>
                </div> : null}

                <CalendlyPop show={showPop} hidePop={() => this.setState({ showPop: false })} />
                {(this.props?.userDetails?.user?.access == 1 && !document.querySelector('.emailverify') && stepCompleted == 0) ? <ExitPopup moveAction={this.moveAction} noFeedCrt={postCount ? false : true} /> : false}
                <Verification products={data} verificationProduct={this.verificationProduct} getAllNetwork={this.getProduct} onEmailVerified={this.startOnboardingChat} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.authenticated.userData,
        userWalls: state.analyticwall?.userfeeds,
        wallData: state.wallData,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        selectProduct: (data, history, callback) => dispatch(selectProduct(data, history, callback)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OnBoarding);

